import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { FatDoctoIDI } from '../../../../../shared/interfaces/fat-docto-i-di';
import { FatDoctoIDIService } from 'app/shared/services/fat-docto-i-di.service';
import { Estado } from 'app/shared/interfaces/estado';
import { Estados } from 'app/shared/inmemory-db/estados';
import { LayoutService } from 'app/shared/services/layout.service';
import { ProdutoService } from 'app/shared/services/produto.service';
import { ProdutoEnums } from 'app/shared/interfaces/produto-enums';
import { CONNECTING } from 'ws';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-lancamento-item-di-popup',
  templateUrl: './lancamento-item-di-popup.component.html',
  styleUrls: ['./lancamento-item-di-popup.component.scss'],
})
export class LancamentoItemDIPopupComponent implements OnInit, OnDestroy {
  public fatDoctoIDIForm: FormGroup;

  fatDoctoIDI: FatDoctoIDI;
  public layoutConf: any;

  estados: Estado[];
  public enums: ProdutoEnums;

  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoItemDIPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private fatDoctoIDIService: FatDoctoIDIService,
    private snack: MatSnackBar,
    private layout: LayoutService,
    private produtoService: ProdutoService,
  ) {
    this.estados = new Estados().estados;
  }

  ngOnInit() {
    console.log(`LancamentoItemDIPopupComponent ngOnInit`)
    this.fatDoctoIDI = this.data.payload;
  
    this.layoutConf = this.layout.layoutConf;
    console.log(`LancamentoItemDIPopupComponent ngOnInit fatDoctoIDI`, this.fatDoctoIDI.formaImportacaoIntermediacao)  
    console.log(`LancamentoItemDIPopupComponent ngOnInit fatDoctoIDI`, this.fatDoctoIDI.transporteInternacional)  
  console.log(`LancamentoItemDIPopupComponent ngOnInit fatDoctoI>>>>`, this.fatDoctoIDI.fatDoctoI)
  console.log(`LancamentoItemDIPopupComponent ngOnInit fatDoctoI>>>>`, this.fatDoctoIDI.fatDoctoI.id.fatProduto.descricao)
    this.buildForm(this.fatDoctoIDI);
    this.produtoService.getEnums().subscribe(enums => {
      this.enums = enums;
      console.log(`LancamentoItemDIPopupComponent ngOnInit enums`, enums) 
      //set enum values to form
      // this.enums.nfformaImportacaoIntermediacao.forEach(element => { 
      //   if(element.codigo == this.fatDoctoIDI.formaImportacaoIntermediacao){
      //     this.fatDoctoIDI.formaImportacaoIntermediacao = element.codigo;
      //   }
      // });
      // this.enums.nfviaTransporteInternacional.forEach(element => {
      //   if(element.codigo == this.fatDoctoIDI.transporteInternacional){
      //     this.fatDoctoIDI.transporteInternacional = element.codigo;
      //   }
      // });
      
    });
  }

  buildForm(fatDoctoIDI: FatDoctoIDI) {
    this.fatDoctoIDIForm = this.fb.group({
      id: [fatDoctoIDI?.id],
      fatDoctoI: [fatDoctoIDI?.fatDoctoI],
      numeroRegistro: [fatDoctoIDI?.numeroRegistro??''],
      dataRegistro: [fatDoctoIDI?.dataRegistro??''],
      localDesembaraco: [fatDoctoIDI?.localDesembaraco??''],
      ufDesembaraco: [fatDoctoIDI?.ufDesembaraco??''],
      dataDesembaraco: [fatDoctoIDI?.dataDesembaraco??''],
      transporteInternacional: [fatDoctoIDI?.transporteInternacional??''],
      valorAFRMM: [fatDoctoIDI?.valorAFRMM??''],
      formaImportacaoIntermediacao: [fatDoctoIDI?.formaImportacaoIntermediacao??''],
      cnpj: [fatDoctoIDI?.cnpj??''],
      ufTerceiro: [fatDoctoIDI?.ufTerceiro??''],
      codigoExportador: [fatDoctoIDI?.codigoExportador??''],
      numero: [fatDoctoIDI?.numero??''],
      sequencial: [fatDoctoIDI?.sequencial??''],
      codigoFabricante: [fatDoctoIDI?.codigoFabricante??''],
      desconto: [fatDoctoIDI?.desconto??''],
      numeroAtoConcessorioDrawback: [fatDoctoIDI?.numeroAtoConcessorioDrawback??''],
      transientFatDoctoIUuid: [fatDoctoIDI?.transientFatDoctoIUuid??''],
      uuid: [fatDoctoIDI?.uuid??''],
      issueDate: [fatDoctoIDI?.issueDate??''],
      updatedAt: [fatDoctoIDI?.updatedAt??''],
      usuarioLog: [fatDoctoIDI?.usuarioLog??''],
    })

  }

  save(): BehaviorSubject<FatDoctoIDI> {
    console.log(`LancamentoItemDIPopupComponent save`)
    if (this.fatDoctoIDIForm.invalid) {
      this.snack.open('Campos obrigatórios não preenchidos, verifique!', 'ERRO', { verticalPosition: 'top', duration: 6500 });
      return;
    }
    
    console.log(`LancamentoItemDIPopupComponent save this.fatDoctoIDIForm.value`, this.fatDoctoIDIForm.value) 

    const result = new BehaviorSubject<FatDoctoIDI>(null);
    this.fatDoctoIDIService.saveOrUpdate(this.fatDoctoIDIForm.value).subscribe(
      (val) => {
        console.log(val);
        this.confirmService.confirm({
          title: 'SALVAR',
          message: 'OK, DI-Declaração de Importação Salvo com Sucesso!', error: false
        });
        result.next(val);
      },
      (err) => {
          result.error(err);
          this.confirmService.confirm({
            title: 'ERRO AO SALVAR, VERIFIQUE',
            message: err.error.status, error: true
          })
        });
        return result;

  }


  ngOnDestroy() {
  }

  close() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close();
        }
      });
  }

}
